export default "__VITE_ASSET__Dryg44Zs__"